var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: ["mobile-search", { active: _vm.active }],
      on: {
        click: function($event) {
          return _vm.$f.showNav("search")
        }
      }
    },
    [
      _c(
        "span",
        { staticClass: "link" },
        [
          _c("f-sprite-icon", {
            attrs: { "icon-link": _vm.$options.icons.IconSearch.id }
          }),
          _vm._v("\n    Поиск\n  ")
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tree-menu depth2" },
        [
          _c(
            "vue-client-only",
            [
              _c("mobile-menu-header", {
                attrs: { title: "Поиск", "show-back": "" },
                on: {
                  back: function($event) {
                    $event.stopPropagation()
                    return _vm.$f.showNav()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mobile-search-container" },
            [_vm.active ? _c("search-form") : _vm._e()],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }